import cx from 'classnames'
import type React from 'react'

import { IconChevronDown } from '../../../../icons'
import type { SelectType } from '../../Select'
import css from './Header.module.scss'

type Props = {
  active?: boolean
  type?: SelectType
  placeholder?: string
  label?: string
  error?: string | null
  selected?: {
    value: string | number
    label: string
  } | null
  disabled?: boolean
  icon?: React.ReactNode
  isOpen: boolean
  inputClassName?: string
  onClick: () => void
  setTargetRef: (el: HTMLElement | null) => void
}

const Header: React.FC<Props> = ({
  active,
  type,
  placeholder = 'Select',
  label,
  error,
  selected,
  disabled,
  icon,
  isOpen,
  inputClassName,
  onClick,
  setTargetRef,
}) => {
  const showSelect = type === 'select'
  const showDefault = !showSelect

  const conditionStyles = {
    [css.active]: active,
    [css.selected]: selected,
    [css.disabled]: disabled,
    [css.open]: isOpen,
  }

  return (
    <div
      className={cx(css.container, {
        [css.error]: error && type === 'input',
      })}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {label && <div className={css.label}>{label}</div>}
      {showSelect && (
        <div className={cx(css.select, conditionStyles)} ref={setTargetRef}>
          {selected ? selected.label : placeholder}

          {!disabled && (
            <IconChevronDown
              className={cx(css.chevron, { [css.rotate]: isOpen })}
            />
          )}
        </div>
      )}
      {showDefault && (
        <div
          className={cx(css.input, inputClassName, conditionStyles)}
          ref={setTargetRef}
        >
          {icon && <span className={css.icon}>{icon}</span>}

          <div className={css.input_value}>
            {selected ? selected.label : placeholder}
          </div>

          {!disabled && (
            <IconChevronDown
              className={cx(css.chevron, { [css.rotate]: isOpen })}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default Header
